import React from 'react';

export const FarewellFeedIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeWidth="1.1"
			d="m12.013 5.926.727 1.12a4.583 4.583 0 0 1-7.618 5.097l-1.474-2.137m1.83-7.748.244-.171a1.17 1.17 0 0 1 1.631.288l2.29 3.27M6.165 7.032 3.642 3.43A.898.898 0 0 1 5.114 2.4l2.523 3.603m-1.422 1.11-2.177-3.11a.996.996 0 1 0-1.632 1.143l2.177 3.11M2.621 5.969l-.246.172a1.17 1.17 0 0 0-.288 1.632l2.308 3.295m7.542-5.26-.986-2.3a.775.775 0 0 0-1.475.444L9.993 6.8s-2.268 1.297-.972 3.568"
		/>
	</svg>
);
